import * as React from 'react'
import { TaskStatusSelectFieldConnected } from './TaskStatusSelectFieldConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskStatusSelectFieldExamples = () => {
  return (
    <div className="TaskStatusSelectFieldExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskStatusSelectFieldConnected />
      </Provider>
    </div>
  )
}
